module.exports = __webpack_public_path__ + "img/img1v2-vertical.6b70b532.png";